import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Admin_Parivartan_Delete_Category,
  Admin_Parivartan_Get_All_Categories,
} from "../../../../constants";
import {
  Box,
  CircularProgress,
  Paper,
  TableBody,
  TableContainer,
  Typography,
  Table,
  TableCell,
  TableRow,
  TableHead,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
} from "@mui/material";

const CategoryTable = ({ categoryList, loading, setLoading, onRefresh}) => {
  
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  

  const handleDeleteCategory = async () => {
    if (!selectedCategoryId) return;

    try {
      setLoading(true);
      const response = await axios.delete(
        `${Admin_Parivartan_Delete_Category}/${selectedCategoryId}`
      );

      if (response.status === 200) {
        console.log("Category deleted successfully");
        setDeleteModalOpen(false);
        onRefresh();
      } else {
        console.error("Failed to delete category");
      }
    } catch (error) {
      console.error("Error deleting category:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      // <div>Loading region assignments...</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <CircularProgress size={24} sx={{ mr: 2 }} />
        <Typography>Loading Categories...</Typography>
      </Box>
    );
  }

  if (!categoryList || categoryList.length === 0) {
    return (
      // <div>No region assignments found.</div>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight={120}
      >
        <Typography>No Categories found.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box p={0}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "grey.100" }}>
                  <TableCell sx={{ fontWeight: 600 }}>ID</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Color</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Created On</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {categoryList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center" sx={{ py: 6 }}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        gap={1}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={48}
                          height={48}
                          fill="none"
                          viewBox="0 0 24 24"
                          style={{ color: "#bdbdbd", marginBottom: 8 }}
                        >
                          <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                          />
                        </svg>
                        <Typography color="text.secondary">
                          No Catgories found
                        </Typography>
                        <Typography variant="body2" color="text.disabled">
                          Try adjusting your search or filters
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                ) : (
                  categoryList.map((category) => (
                    <TableRow key={category.CategoryId}>
                      <TableCell>
                        <Typography variant="body2" fontFamily="monospace">
                          {category.CategoryId}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" fontWeight="500">
                          {category.CategoryName}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Box display="flex" alignItems="center" gap={1}>
                          <Box
                            sx={{
                              width: 20,
                              height: 20,
                              borderRadius: "4px",
                              backgroundColor: category.Color,
                              border: "1px solid #ccc",
                            }}
                          />
                          <Typography variant="body2" fontFamily="monospace">
                            {category.Color}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Typography variant="body2" fontFamily="monospace">
                          {new Date(category.CreatedAt).toLocaleDateString(
                            "en-IN",
                            {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Button
                          size="small"
                          variant="outlined"
                          color="warning"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedCategoryId(category.CategoryId);
                            setCategoryName(category.CategoryName);
                            setDeleteModalOpen(true);
                          }}
                        >
                          Delete
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>

      {/* Delete Confirmation Modal */}
      <Dialog
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Delete Category</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete the category{" "}
            <Box component="span" fontWeight="bold" display="inline">
              {categoryName}
            </Box>
            ?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDeleteModalOpen(false)}
            disabled={loading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDeleteCategory}
            color="error"
            disabled={loading}
            variant="contained"
          >
            {loading ? (
              <>
                <CircularProgress size={18} sx={{ mr: 1 }} />
                Deleting...
              </>
            ) : (
              "Delete"
            )}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CategoryTable;
